module.exports = __webpack_public_path__ + "img/sort_up.b35040ee.svg";